module.exports = __webpack_public_path__ + "static/img/witness-teens-3.c2a99618.png";